// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import Tdg_FeedbackListPagingResultModel from '../../model/tdg-feedback-list-paging-result-model';
import Tdg_FeedbackListPagingResultDTO from '../dto/tdg-feedback-list-paging-result-dto';
import dtoSchema from '../schemas/tdg-feedback-list-paging-result-schema';
import Tdg_FeedbackListModel from '../../model/tdg-feedback-list-model';
import ResourceLinkModel from '../../model/resource-link-model';
import PaginationDataModel from '../../model/pagination-data-model';

export default abstract class Tdg_FeedbackListPagingResultModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<Tdg_FeedbackListPagingResultDTO>) {
    super();
    if (data) {
      this.items = data.items?.map((i) => Tdg_FeedbackListModel.toModel(i)) ?? [];
      this.links = data.links?.map((i) => ResourceLinkModel.toModel(i)) ?? [];
      this.paginationData = data.paginationData ? PaginationDataModel.toModel(data.paginationData) : undefined;
    }
  }
  /**
  */
  items?: Tdg_FeedbackListModel[];
  /**
  */
  links?: ResourceLinkModel[];
  /**
  */
  paginationData?: PaginationDataModel;

  static toModel(dto: DeepPartial<Tdg_FeedbackListPagingResultDTO>): Tdg_FeedbackListPagingResultModel;
  static toModel(dto: DeepPartial<Tdg_FeedbackListPagingResultDTO> | undefined | null): Tdg_FeedbackListPagingResultModel | undefined;
  static toModel(dto: DeepPartial<Tdg_FeedbackListPagingResultDTO> | undefined | null): Tdg_FeedbackListPagingResultModel | undefined {
    return dto ? new Tdg_FeedbackListPagingResultModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<Tdg_FeedbackListPagingResultModel> | Tdg_FeedbackListPagingResultModel): Tdg_FeedbackListPagingResultDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      items: unwrapped.items,
      links: unwrapped.links,
      paginationData: unwrapped.paginationData,
    } as Tdg_FeedbackListPagingResultDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for Tdg_FeedbackListPagingResultModel, can not map to Tdg_FeedbackListPagingResultDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
